export default __webpack_public_path__ + "static/media/20ans.33538f02.png";